import {
  stringifyParams
} from 'helpers/query_params';

angular.module('gym.payouts').controller('PayoutItemsCtrl', ["$rootScope", "$scope", "$state", "$stateParams", "ngTableParams", "EmploymentService", "Payouts", "loadingAnimation", "payout", function($rootScope, $scope, $state, $stateParams, ngTableParams, EmploymentService, Payouts, loadingAnimation, payout) {
  var getTotal, gym, permissions;
  gym = $rootScope.gym;
  $scope.payout = payout;
  permissions = EmploymentService.get().permissions;
  if (!gym.uses_gocardless || !permissions.view_payouts) {
    $state.go('gym.dashboard');
  }
  $scope.currency = gym.currency_symbol;
  $scope.filters = {};
  getTotal = function(items, field) {
    return _.reduce(items, function(sum, item) {
      if (item[field]) {
        return sum + parseFloat(item[field]);
      } else {
        return sum;
      }
    }, 0);
  };
  return $scope.tableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      var params;
      loadingAnimation.show();
      params = angular.extend(stringifyParams({
        filters: $scope.filters
      }), $params.url());
      return payout.all('payout_items').getList(params).then(function(data) {
        $params.total(data.meta.total);
        loadingAnimation.hide();
        $scope.totalAmount = getTotal(data, 'amount');
        $scope.totalTax = getTotal(data, 'tax_amount');
        return $defer.resolve(data);
      });
    }
  });
}]);
